/**
 * Slots always rendered. The unlit ones give the scale away without the
 * brand having to count, which is what lets a list read as a gradient when it
 * is sorted by match.
 */
export const FLAME_SLOTS = 3;
/**
 * Lit flames per tier. This mirrors the backend `deriveMatchTier`, which
 * counts aligned fit dimensions: 0 -> unfit, 1 -> moderate, 2 -> good,
 * 3 or more -> excellent. One flame is therefore one aligned dimension.
 */
export const litFlameCount = {
    excellent: 3,
    good: 2,
    moderate: 1,
    unfit: 0,
};
export function isPositiveMatchTier(tier) {
    return tier === 'moderate' || tier === 'good' || tier === 'excellent';
}
/**
 * Maps a 0-100 match score onto the tier scale.
 *
 * Used by the surfaces that only expose a score (Discovery search cards, the
 * mention opportunity panel) so they can render the same flame scale as the
 * recommendations list, where the tier comes straight from the backend
 * `deriveMatchTier`. The agent never sends a score: it sends the tier.
 *
 * The thresholds look low against an absolute reading of "80% fit", and that
 * is deliberate: the score is not an absolute fit measure. creator-api
 * `Calibrate` affinely rescales the brand's own [p5, p99] cosine band onto
 * [0, 100], precisely because the natural band of well-matched creators is
 * narrow. So the whole 0-100 range is spent inside one brand's candidate
 * pool, and a score reads as a position in that pool, not as a verdict.
 *
 * Two consequences pin the values:
 *   - a degenerate calibration (p5 >= p99, or missing bounds) returns exactly
 *     50. It has to land in `moderate`, never in `unfit`, or "score still
 *     calibrating" would render as "not a fit" — the one confusion the flame
 *     scale exists to avoid.
 *   - 80 is already the `STRONG_MATCH_SCORE` gate on the mention opportunity
 *     row. Raising the top tier above it would print two flames next to a
 *     "strong signal" badge on the same line.
 */
export function matchScoreToTier(score) {
    if (score === null || score === undefined || Number.isNaN(score))
        return null;
    if (score >= 80)
        return 'excellent';
    if (score >= 60)
        return 'good';
    if (score >= 40)
        return 'moderate';
    return 'unfit';
}
